export let UserDetailsMockData = {
  bankAccounts: [
    {
      crmId: 12,
      bankCode: 'NDB',
      bankName: 'NDB',
      branchCode: 'Malabe',
      branchName: 'Malabe',
      accountType: 'Savings',
      accountNo: '11111111'
    },
    {
      crmId: 13,
      bankCode: 'Commercial Bank',
      bankName: 'Commercial Bank',
      branchCode: 'Negombo',
      branchName: 'Negombo',
      accountType: 'Current',
      accountNo: '2222222'
    },
    {
      crmId: 14,
      bankCode: 'Commercial Bank',
      bankName: 'Commercial Bank',
      branchCode: 'Negombo',
      branchName: 'Negombo',
      accountType: 'Current',
      accountNo: '333333'
    }
  ],
  addresses: [
    {
      id: '1',
      addressLine1: '4, Anderson Road',
      addressLine2: 'Seastreet',
      city: 'Negombo',
      country: 'Sri Lanka',
      postalCode: '11500',
      province: 'Western',
      district: 'Gampaha',
      customerId: '1222'
    },
    {
      id: '2',
      addressLine1: '10A/234, Cemetry Road',
      addressLine2: 'Udugampola',
      city: 'Gampaha',
      country: 'Sri Lanka',
      postalCode: '11300',
      province: 'Western',
      district: 'Gampaha',
      customerId: '1223'
    }
  ],
  other: [
    {
      id: '1222',
      type: 'MOBILE_PHONE',
      value: '+94777301150',
      customerId: '111'
    },
    {
      id: '1222',
      type: 'MOBILE_PHONE',
      value: '+94702301150',
      customerId: '111'
    },
    {
      id: '1222',
      type: 'MOBILE_PHONE',
      value: '+94762301150',
      customerId: '111'
    }
  ]
};

export let LovDataLocal = {
  proofOfRecedency: {
    NIC: 'National Identity Card',
    PASSPORT: 'Passport',
    DRIVING_LICENSE: 'Driving License',
    BANK_CREDIT_CARD_STATEMENT: 'Bank/ Credit card Statement',
    TELEPHONE_BILL: 'Telephone Bill',
    ELECTRCITY_BIL: 'Electricity Bill',
    WATER_BILL: 'Water Bill',
    REGISTERED_LEASE_AGREEMENT: 'Registered Lease Agreement',
    GRAMASEVAKA_CERTIFICATE: 'Gramasevaka Certificate certified by the Divisional Secretary',
    LETTER_ISSUED_BY_SUPERINTENDENT_OF_A_PLANTATION_ESTATE:
      'Letter issued by a superintendent of a plantation estate in respect of estate workers who have no other documentary proof'
  }
};

export let scaterData = [
  {
    name: 'Abans',
    id: '001',
    date: ['2019-12-30', '2019-12-31', '2020-01-03', '2020-01-06', '2020-01-07'],
    x: ['3852', '510', '1249', '2661', '689'],
    y: ['95.2', '95.7', '96.50', '95.80', '93.00'],
    marker: { size: ['191740.41', '191149.73', '190976.67', '192686.60', '192156.03'] }
  },
  {
    name: 'Abans Finance',
    id: '003',
    date: ['2019-12-30', '2019-12-31', '2020-01-03', '2020-01-06', '2020-01-07'],
    x: ['11195', '0', '1', '0', '400'],
    y: ['20.7', '20.7', '21', '21', '20.7'],
    marker: { size: ['16821.19', '16751.68', '16647.41', '16716.49', '16681.63'] }
  },

  {
    name: 'ACL',
    id: '002',
    date: ['2019-12-30', '2019-12-31', '2020-01-03', '2020-01-06', '2020-01-07'],
    x: ['65711', '188325', '42064', '141674', '673475'],
    y: ['57.2', '57.5', '57.4', '56', '55.8'],
    marker: { size: ['3118277.68', '3150083.58', '3159586.40', '3204446.93', '3347305.19'] }
  }
];

export let frame = [
  {
    name: '2019-11-21',
    data: [
      {
        x: [82.3],
        id: 1,
        y: [1324],
        marker: {
          size: [109445]
        }
      },
      {
        x: ['65711'],
        id: '2',
        y: ['57.2'],
        marker: {
          size: ['3118277.68']
        }
      },
      {
        x: ['11195'],
        id: '003',
        y: ['20.7'],
        marker: {
          size: ['16821.19']
        }
      }
    ]
  },
  {
    name: '2019-11-20',
    data: [
      {
        x: ['510'],
        y: ['95.7'],
        marker: {
          size: ['191149.73']
        }
      },
      {
        x: ['188325'],
        id: '002',
        y: ['57.5'],
        marker: {
          size: ['3150083.58']
        }
      },
      {
        x: ['0'],
        id: '003',
        y: ['20.7'],
        marker: {
          size: ['16751.68']
        }
      }
    ]
  },
  {
    name: '2020-01-03',
    data: [
      {
        x: ['1249'],
        y: ['96.50'],
        marker: {
          size: ['3159586.40']
        }
      },
      {
        x: ['42064'],
        id: '002',
        y: ['57.4'],
        marker: {
          size: ['191875.43']
        }
      },
      {
        x: ['1'],
        id: '003',
        y: ['21'],
        marker: {
          size: ['16647.41']
        }
      }
    ]
  },
  {
    name: '2020-01-06',
    data: [
      {
        x: ['2661'],
        y: ['95.80'],
        marker: {
          size: ['192686.60']
        }
      },
      {
        x: ['141674'],
        id: '002',
        y: ['56'],
        marker: {
          size: ['3204446.93']
        }
      },
      {
        x: ['0'],
        id: '003',
        y: ['21'],
        marker: {
          size: ['16716.49']
        }
      }
    ]
  },
  {
    name: '2020-01-07',
    data: [
      {
        x: ['689'],
        y: ['93'],
        marker: {
          size: ['192156.03']
        }
      },
      {
        x: ['673475'],
        id: '002',
        y: ['55.8'],
        marker: {
          size: ['3347305.19']
        }
      },
      {
        x: ['400'],
        id: '003',
        y: ['20.7'],
        marker: {
          size: ['16681.63']
        }
      }
    ]
  }
];
